/* src/app/components/companies-components/companies-company-services-card/companies-company-services-card.component.scss */
.services-card footer > div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
/*# sourceMappingURL=companies-company-services-card.component.css.map */
